import { ApiStatuses } from '../../../../global/models/api-model';
import { DemographicAppKeys } from '../../../../global/models/demographics-model';
import { Person } from '../../../../global/models/person-model';

export enum RelationshipsActionTypes {
	SET_SPOUSES = 'SET_SPOUSES',
	SET_SPOUSE_PERSON = 'SET_SPOUSE_PERSON',
	ADD_LOADING_SPOUSE_PERSON = 'ADD_LOADING_SPOUSE_PERSON',
	SET_CHILDREN = 'SET_CHILDREN',

	PATCH_SPOUSE_STATUS = 'PATCH_SPOUSE_STATUS',
	POST_SPOUSE_STATUS = 'POST_SPOUSE_STATUS',
	UPDATE_SPOUSE = 'UPDATE_SPOUSE',
	UPDATE_SPOUSE_PERSON = 'UPDATE_SPOUSE_PERSON',
	WIDOWED_STATUS = 'WIDOWED_STATUS',
	DIVORCED_STATUS = 'DIVORCED_STATUS',
	UNLOAD_RELATIONSHIPS_STATE = 'UNLOAD_RELATIONSHIPS_STATE',
	SINGLE_STATUS = 'SINGLE_STATUS',
	LEGALLY_SEPARATED_STATUS = 'LEGALLY_SEPARATED_STATUS',
	SET_SPOUSE_UNLOADED = 'SET_SPOUSE_UNLOADED',
}

export interface Spouse {
	_guid: string;
	person_guid: string;
	end_date?: string | undefined;
	client_nbr?: string | undefined;
	legal_separation_date?: string | undefined;
	marriage_end_reason?: string | undefined;
	marriage_cert_recvd_indicator?: string | undefined;
	start_date: string;
	first_name: string;
	last_name: string;
	person: Person;
	court_issuing_decree?: string;
	case_number?: number;
	date_of_death?: string;
}

export interface RelationshipsState {
	spouses: Spouse[];
	loadingSpousePersons: number;
	loadingSpouses: boolean;
	spousesFetched: boolean;
	childrenFetched: boolean;
	patchSpouseStatus: ApiStatuses;
	postSpouseStatus: ApiStatuses;
	widowedStatus: ApiStatuses;
	divorcedStatus: ApiStatuses;
	singleStatus?: ApiStatuses;
	legalSeperationStats?: ApiStatuses;
}

export interface RelationshipsAppState {
	[DemographicAppKeys.myCPG]: RelationshipsState;
	[DemographicAppKeys.arc]: RelationshipsState;
}
